jQuery(document).ready(function($){
	function customScrollbars() {
		$('.slider_wrapper').each(function(i, obj) {
			var $this = $(this);
			var holder = $this.find('.slider_holder');
			var track = $this.find('.slider_track');
			var container_offset = $this.find('.grid-container').offset();
			track.css({'padding-left':container_offset.left + 15,'padding-right':container_offset.left + 15});
			// Scrollbar functionality
			var scrollbarWidth = $this.find('.slider_scroll_bar').width();
			var handleWidth = $this.find('.handle').width();
			var remaining = scrollbarWidth - handleWidth;
			var hsWidth = track[0].scrollWidth - track[0].clientWidth; 
	    	var percent;
	    	var scrollPercent;
	    	var leftScroll = $this.find('.scroller.left');
	    	var rightScroll = $this.find('.scroller.right');
	    	leftScroll.on('click', function() {
	    		track.animate({ scrollLeft: "0px" }, 600);
	    	});
	    	rightScroll.on('click', function() {
	    		track.animate({ scrollLeft: hsWidth }, 600);
	    	});
	    	$this.find('.handle').draggable({
				axis: 'x',
				containment: 'parent',
				drag: function (event, ui) {
					percent = (ui.position.left/remaining);
					track.scrollLeft(percent*hsWidth);
				}
			});
			track.on('scroll', function() {
				scrollPercent = ($(this).scrollLeft()/(track[0].scrollWidth - track[0].clientWidth));
				$this.find('.handle').css({left:(scrollPercent*remaining)});
			});
		});
	}
	customScrollbars();

	var element = $(window);
	var current_size = element.width()+'x'+element.height();
	var current_width = element.width();
	var shrinking = false;
	var growing = false;
	var resizeTimer;
	element.resize(function(){
		customScrollbars();
		
		var this_size = $(this).width()+'x'+$(this).height();
		if (current_width > $(this).width()){
			shrinking = true;
			growing = false;
			if($(this).width() <= 1024) {
			}
		}
		if (current_width < $(this).width()){
			growing = true;
			shrinking = false;
			if($(this).width() >= 1024) {
			}
		}
		if (current_size!==this_size){
			current_size = this_size;
			current_width = $(this).width();
		}
	});
	if (current_width < 1024) {
	}

	// Alert Banner
	$('.alert_banner').each(function(num, elem) {
		let $elem = $(elem);
		let $alertID = $(this).data('alert');
		if (JSON.parse(localStorage.getItem(`${$alertID}`)) === null) {
			setTimeout(function () {
				$elem.slideDown();
			}, 500);
		} else if (typeof (JSON.parse(localStorage.getItem(`${$alertID}`))) === 'boolean') {
			if (!JSON.parse(localStorage.getItem(`${$alertID}`))) {
				$elem.slideUp();
			}
		}
		let $alertClose = $(this).find('.alertClose');
		$alertClose.click(function() {
			$elem.slideUp();
			localStorage.setItem(`${$alertID}`, 'true');
		});
	});


	// Filters functionality
	var $filtered = false;
	var $activeFilters = 0;
	$('.filtersHolder').each(function(i, obj) {
		$('.filtersHolder .filter_toggle').each(function(i, obj) {
			var $this = $(this);
			$this.on('click', function() {
				let $id = `#${$this.data('toggle')}`; // Getting id of section to be filtered
				$($this).toggleClass('active'); // Toggle 'active' class on filter button
				$activeFilters = $('.filter_toggle.active').length; // Count active filters
				// If filtered previously and no remaining toggles have 'active' class, show all sections
				if($filtered && $activeFilters === 0) {
					$('.faqWrapper').slideDown().removeClass('inactive');
					$filtered = false; }
				// If filtered, toggle selected section
				else if ($filtered) {
					$($id).slideToggle().toggleClass('inactive');
				// If not filtered at all, set filtered to true and close all sections other than selected section
				} else {
					$('.faqWrapper:not('+$id+')').slideUp().addClass('inactive');
					$filtered = true;
				}
			});
		});
	});
	$('#clear_filters').on('click', function() {
		$('.faqWrapper').slideDown().removeClass('inactive');
		$('.filtersHolder .filter_toggle').removeClass('active');
		$filtered = false;
		$activeFilters = 0;
	});

	var mastvideo = document.getElementById('mast-video');
	$('#mast-video-reveal').on('open.zf.reveal', function(event) {
		mastvideo.play();
	});
	$('#mast-video-reveal').on('closed.zf.reveal', function(event) {
		mastvideo.pause();
		mastvideo.currentTime = 0;
		mastvideo.load();
	});
	$('.program_video').each(function(i, obj) {
		let program_video = $(obj).find('iframe');
		let vidsrc = program_video.attr('src');
		// $(obj).on('open.zf.reveal', function(event) {
		// 	console.log('Hiyo');
		// 	console.log(program_video);
		// 	console.log(vidsrc);
		// });
		$(obj).on('closed.zf.reveal', function(event) {
			program_video.attr('src','');
			program_video.attr('src',vidsrc);
		});
	});
	
	$('.results_card').each(function(i, obj) {
		// console.log(obj);
		let title = $(obj).find('.title').text();
		let link = $(obj).find('.card_link').attr('href');
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'g_form_track',
			'action': 'program_recommend',
			'program_title': title,
			'uri': link,
		});
	});
});